import {showAlert} from '../service';
import openAppSettings from './openAppSettings';

const handlePermissionError = (e, source) => {
  const isPermissionError = e?.toString().includes('User did not grant');
  if (isPermissionError) {
    showAlert(
      'Permission Error',
      `Please grant permission to access your ${source}.`,
      () => console.log('Cancel Pressed'),
      () => void openAppSettings(source),
    );
  }
};

export default handlePermissionError;
